import React, { useState } from 'react'
import BaseListing from 'src/BaseListings'
import RatingStars from 'src/widgets/RatingStars/RatingStars'

export default function RecommendationEvaluationTemplate({ viewOnly = false, ratingData, onChange, onChangeDynamicFields, templateFields }) {
  const Base = new BaseListing()
  const [maxRating] = useState(templateFields.length * 10);

  const getTotalRating = () => {
    let total = 0
    templateFields.map((item) => {
      total += item.recommended_ratings
    })
    return total
  }

  const getSubmittedRating = () => {
    let total = 0
    templateFields.map((item) => {
      total += item.ratings
    })
    return total
  }

  return (
    <>
      <div style={{ padding: '10px' }}>
        <table
          width="100%"
          className="table table-striped"
          style={{
            marginTop: '16px',
            borderCollapse: 'collapse',
            fontFamily: 'Arial, sans-serif',
          }}
        >
          <tbody>
            <tr>
              <th style={{ width: '70px' }}>Misc. Aspects</th>
              <th style={{ width: '24px' }}>Submitted Ratings</th>
              <th style={{ width: '24px' }}>RATING FACTORS</th>
              <th style={{ width: '6px' }}>RATING</th>
            </tr>
            {templateFields.map((item, index) => (
              <tr key={item.key}>
                <td>
                  <strong>{item.label}</strong>
                </td>
                <td>
                  <strong>{item.ratings}</strong>
                </td>
                <td>
                  <RatingStars
                    count={10}
                    value={item.recommended_ratings}
                    onChange={(value) => onChangeDynamicFields(item.key, value, index)}
                    viewOnly={viewOnly}
                  />
                </td>
                <td>
                  <b style={{ color: 'blue' }} readOnly={viewOnly}>
                    {item !== null ? `${item.recommended_ratings}/10` : ''}
                  </b>
                </td>
              </tr>
            ))}
            <tr>
              <td>
                <b readOnly={viewOnly}>Overall Performance:</b>
              </td>
              <td style={{ color: 'green', fontWeight: 'bold' }}> {getSubmittedRating()} / {maxRating}</td>
              <td></td>
              <td style={{ color: 'green', fontWeight: 'bold' }}> {getTotalRating()} / {maxRating}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </>
  )
}
